module.exports = __webpack_public_path__ + "img/jingqu.83d3eb34.png";